<template>
  <div id="app">
    <!-- <div v-if="isLoading" class="clicking-mask">
      <div class="loading"></div>
    </div> -->
    <Layout />
    <div class="clicking-mask" id="loading-marsk">
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue'
import Layout from '@/components/Layout'
import { useStore } from 'vuex';
import { checkExistsFuncName } from './utils/const';
export default defineComponent({
  components: {
    Layout
  },
  mounted() {
    // 获取用户信息
    document.addEventListener("DOMContentLoaded", function () {
      // 判断有没有 loading-img; 提前动态加载loading.gif 资源
      let loadingMaskEl = document.getElementById("loading-marsk");
      if (!checkExistsFuncName("LoadingPage")) {
        console.log("需要兼容老版本loading~~~");

        let imgEl = document.getElementById("loading-img") as HTMLImageElement;
        if (!imgEl) {
          imgEl = document.createElement("img") as HTMLImageElement;
          imgEl.src =
            "https://mymall.mall.hk.chinamobile.com/csapp/common/loading-large.gif";
          imgEl.alt = "Loading";
          imgEl.id = "loading-img";
          console.log("loadingMaskEl:",loadingMaskEl)
          loadingMaskEl!.appendChild(imgEl);
        }
      }

      loadingMaskEl!.style.display = "none";
    });
  },
  setup() {
    const store = useStore()
    const isLoading = computed(() => store.state.load.loading)
    return {
      isLoading
    }
  }
})
</script>
<style lang="less">
@import 'assets/loading.less';
html {
  //height: 100%;
}
body {
  //height: 100%;
  #app {
    //height: 100%;
  }
  /* 在全局样式文件中添加  vant toast*/
  .custom-toast {
    /* 防止单词断开 */
    word-break: keep-all !important;
    
    /* 保持空白处理 */
    white-space: pre-wrap !important;
    
    /* 允许弹性宽度 */
    max-width: 80vw !important; /* 限制最大宽度 */
    min-width: 200px !important; /* 保证最小宽度 */
    /* 文本对齐优化 */
    text-align: center !important;
    
    /* 移动端特殊处理 */
    -webkit-hyphens: none !important;
    hyphens: none !important;
  }
}


</style>
